import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.5 5a1 1 0 0 1 1-1h1.79A2.71 2.71 0 0 1 20 6.71v1.58A2.71 2.71 0 0 1 17.29 11h-1.755l-2.703 4.055A1 1 0 0 1 12 15.5H8.969q.03.245.031.5a4 4 0 1 1-2.417-3.674V10.56q.001-.37.094-.71H6.5a1 1 0 0 1 0-2h3.25a1 1 0 1 1 0 2h-.457a.71.71 0 0 0-.71.71v2.94h2.882l2.703-4.055A1 1 0 0 1 15 9h2.29a.71.71 0 0 0 .71-.71V6.71a.71.71 0 0 0-.71-.71H15.5a1 1 0 0 1-1-1M6.793 15.113a1 1 0 0 1-.134-.23 2 2 0 1 0 .133.23M17 16a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_bike-opCQESdV.js.map
